/* jshint esversion: 6, sub:true */
const $ = require('jquery');
import PubSub from 'pubsub-js';
import { TweenMax, Power4 } from 'gsap';
import { requestFrame } from './helpers';

import CustomEase from '../vendors/CustomEase';

const ACTIVE_STATE = 1,
	INACTIVE_STATE = 0,
	URL = `${CCM_APPLICATION_URL}/application/themes/tentwenty/images/menu/Menu_000`,
	TOTAL_FRAMES = 23,
	LinksEase = CustomEase.create('custom', 'M0,0 C0.05,1 0.818,1 1,1');

class HeaderMenu {
	constructor() {
		this.el = $('header#siteHeader');
		this.menuButton = this.el.find('.hamburger button');
		this.links = this.el.find('.links-container li');
		this.state = INACTIVE_STATE;
		this.animating = false;


		var element = document.getElementById('menuAnimation');
		element.style.display = 'block';
		var config = {
			startOnLoad: false,
			container: element,
			renderer: 'svg',
			loop: false,
			autoplay: false,
			name: 'menuAnim',
			path: CCM_APPLICATION_URL + '/application/themes/tentwenty/js/app/menu_40.json'
		};
		window.menuAnim = bodymovin.loadAnimation(config);
		this.addEvents();
	}

	addEvents() {
		const scope = this;
		let animating = false;
		this.menuButton.on('click', function() {
			console.log('click me', animating);
			if (animating) {
				return;
			}
			animating = true;
			setTimeout(() => {
				animating = false;
			}, 600);
			scope.menuButton.removeClass('change-color');

			if (scope.state == ACTIVE_STATE) {
				scope.state = INACTIVE_STATE;
				scope.playMenuAnimation(true);
				TweenMax.staggerFromTo(
					scope.links.get().reverse(),
					0.5,
					{ autoAlpha: 1, y: 0 },
					{ autoAlpha: 0, y: 100, ease: LinksEase },
					0.05,
					() => {
						$(this).removeClass('active show-tabs sticky--no-bg show-tabs sticky');
						scope.el[0].className = scope.el.data('classes');
					}
				);
				return;
			}

			if ('requestIdleCallback' in window) {
				requestIdleCallback(
					() => {
						scope.playMenuAnimation();
					},
					{ timeout: 500 }
				);
			} else {
				scope.playMenuAnimation();
			}

			scope.state = ACTIVE_STATE;
			scope.el.data('classes', scope.el[0].className);

			scope.el.addClass('inverse active');
			$(this).addClass('active');

			TweenMax.staggerFromTo(
				scope.links,
				0.5,
				{ autoAlpha: 0, y: 100 },
				{ autoAlpha: 1, y: 0, ease: LinksEase },
				0.05
			);
		});

		PubSub.subscribe('close-menu', () => {
			this.closeMenu();
			scope.playMenuAnimation(true);
		});
	}

	closeMenu() {
		//check if menu is open or not
		if (this.state == INACTIVE_STATE) return;

		this.state = INACTIVE_STATE;

		setTimeout(() => {
			TweenMax.staggerFromTo(
				this.links.get().reverse(),
				0.5,
				{ autoAlpha: 1, y: 0 },
				{ autoAlpha: 0, y: 100, ease: LinksEase },
				0.05,
				() => {
					this.menuButton.removeClass('active');
					this.el.removeClass('active');
				}
			);
		}, 300);
	}

	playMenuAnimation(reverse = false){
		const dir = reverse ? -1 : 1;
		if(reverse){
			bodymovin.setSpeed(2, 'menuAnim');
		}else{
			bodymovin.setSpeed(1, 'menuAnim');
		}
		bodymovin.setDirection(dir) ;
		window.menuAnim.play();
	}
}

export default HeaderMenu;


// WEBPACK FOOTER //
// ./app/components/header-menu.js